import { DevHubTypography, DevHubLink } from '@devxdiscover/devhub-ui';
import { CopyIdButton } from './CopyIdButton';

interface IdeaMetadataProps {
  applicationId: number | string;
  ownerText: string;
  variant?: 'small' | 'medium';
  catalogLink?: string;
}

/**
 * Displays idea metadata including application ID with copy button and owner information.
 * Supports two size variants for different contexts.
 *
 * @param props - Component props
 */
export const IdeaMetadata = ({
  applicationId,
  ownerText,
  variant = 'medium',
  catalogLink,
}: IdeaMetadataProps) => {
  const isSmall = variant === 'small';
  const fontSize = isSmall ? '0.75rem' : '0.875rem';
  const typographyVariant = isSmall ? 'caption' : 'body2';

  const href = catalogLink || `/catalog/default/system/${applicationId}`;

  return (
    <DevHubTypography
      variant={typographyVariant}
      color="textSecondary"
      style={{
        display: 'flex',
        alignItems: 'center',
        fontWeight: isSmall ? 400 : 500,
      }}
    >
      <span>
        ID: <DevHubLink href={href}>{applicationId}</DevHubLink>
      </span>
      <CopyIdButton value={applicationId} fontSize={fontSize} />
      <span style={{ marginLeft: 4 }}>• Owner: {ownerText}</span>
    </DevHubTypography>
  );
};
